<template>
  <Section class="text-bloc" wide-mode no-space>
    <div class="wrapper">
      <h2 class="title">{{ bloc.title }}</h2>
      <cms-components-rich-text class="content" :text="bloc.content" />
    </div>
  </Section>
</template>

<script>
export default {
  props: {
    bloc: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="less" scoped>
.text-bloc {
  margin-bottom: 32px;
}

.wrapper {
  padding: 24px;
  background: var(--ds-color-white-100);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.06), 0 3px 8px rgba(0, 0, 0, 0.1);
}

.title {
  font-weight: 400;
  font-size: 32px;
  color: var(--ds-color-primary-100);
  margin-bottom: 12px;
}

.content {
  font-weight: 400;
  font-size: 14px;
  color: var(--ds-color-gray-50);
}

@media @bp-desktop {
  .text-bloc {
    margin-bottom: 48px;
  }
}
</style>
